import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_cockpit/cockpit/kurse")({
  component: () => <Outlet />,
});
